import { React } from 'react'
import { Typography, Box, Icon } from '@mui/material'

const StatusBar = ({ status, icon, sx, ...rest }) => {
  let fontColor
  let barColor
  let text

  switch (status) {
    case 'APPROVED':
      text = 'Approved'
      fontColor = 'positive.main'
      barColor = 'positive.light'
      break

    case 'REJECTED':
      text = 'Rejected'
      // fontColor = "light-gray-text.main";
      fontColor = 'error.main'
      // barColor = "gray-background.main";
      barColor = 'light-error.main'
      break

    case 'PENDING':
      text = 'Awaiting Approval'
      fontColor = 'yellow-01.main'
      barColor = 'light-yellow-01.main'
      break

    case 'PENDING_DOCUMENT':
      text = 'Awaiting Document'
      fontColor = 'white.main'
      barColor = 'yellow-01.main'
      break
    case 'WITHDRAWN':
      text = 'Withdrawn'
      fontColor = 'light-gray-text.main'
      barColor = 'gray-background.main'
      break
    case 'DRAFT':
      text = 'Draft'
      fontColor = 'yellow-01.main'
      barColor = 'light-yellow-01.main'
      break
    case 'REIMBURSED':
      text = 'Reimbursed'
      fontColor = 'positive.main'
      barColor = 'positive.light'
      break
    case 'AUTO-GENERATED':
      text = 'Auto-Generated'
      fontColor = 'white.main'
      barColor = 'light-gray-text.main'
      break
    case 'ongoing':
      text = 'Ongoing'
      fontColor = 'yellow-01.main'
      barColor = 'light-yellow-01.main'
      break
    case 'completed':
      text = 'Completed'
      fontColor = 'positive.main'
      barColor = 'positive.light'
      break
    case 'upcoming':
      text = 'Upcoming'
      fontColor = 'information.main'
      barColor = 'light-information.main'
      break
    default:
      text = status.text ? status.text : 'Default'
      fontColor = status.color ? status.color : 'positive.main'
      barColor = status.bgColor ? status.bgColor : 'positive.light'
      break
  }

  const styleBox = () => {
    return {
      backgroundColor: barColor,
      py: 0.5,
      px: 1.5,
      borderRadius: '15px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
      columnGap: icon ? 2 : 0,
    }
  }

  const styleIcon = () => ({
    color: fontColor,
    display: 'flex',
    alignItems: 'center',
  })

  return (
    <Box sx={{ ...styleBox(), ...sx, ...rest }}>
      {icon ? (
        <Box sx={{ ...styleIcon() }}>
          <Icon>{icon}</Icon>
        </Box>
      ) : null}

      <Typography variant="subtitle2" color={fontColor} sx={{ textAlign: 'center' }}>
        {text}
      </Typography>
    </Box>
  )
}

export default StatusBar
